import GreenCircleTick from '../../icons/GreenCircleTick'
import { RightChevron } from '../../icons/questionnaire/RightChevron'
import { useBottomSheet } from '../../state-management/contexts/BottomSheetContext'
import { WithdrawnFundsBottomSheetContent } from './WithdrawnFundsBottomSheetContent'
import { RegularToDirectSummaryResponse } from '../../types/regular-to-direct-plan.types'
import { trackEvent } from '../../utils/appBridge'
import { EventNames } from '../../types/misc.types'

interface WithdrawnFundsProps {
  summaryData: RegularToDirectSummaryResponse | undefined
  isLoading: boolean
  isError: boolean
}

export const WithdrawnFunds = ({ summaryData, isLoading, isError }: WithdrawnFundsProps) => {
  const { openBottomSheet } = useBottomSheet()

  // Filter funds where exited is true
  const withdrawnFunds = summaryData?.regularFunds?.filter((fund) => fund.exited) || []

  if (isLoading || isError || !summaryData || withdrawnFunds.length === 0) {
    return null
  }

  const handleClick = () => {
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        eventId: 'WithdrawnFunds',
        responseName: 'Open',
        screenType: 'REGULAR_TO_DIRECT_PLAN_ELITE_PAGE'
      }
    })
    openBottomSheet(<WithdrawnFundsBottomSheetContent withdrawnFunds={withdrawnFunds} />)
  }

  return null

  return (
    <div onClick={handleClick} className='pl-5 flex flex-row w-full cursor-pointer my-2'>
      <div className='flex flex-row gap-3 items-center'>
        <div className='w-10 h-10 flex items-center justify-center'>
          <GreenCircleTick size={24} className='align-middle' />
        </div>
      </div>
      <div className='flex flex-row gap-3 items-center flex-1 justify-between ml-5'>
        <div className='py-4'>
          <div className='text-13 font-medium'>
            {withdrawnFunds.length} regular {withdrawnFunds.length === 1 ? 'fund' : 'funds'} withdrawn
          </div>
        </div>
        <div className='flex items-center justify-center w-10 h-full pr-5'>
          <RightChevron />
        </div>
      </div>
    </div>
  )
}
